import React, { useEffect, useState } from 'react';
import axios from '../../../services/axios';
import {
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  Typography,
  Tabs,
  Tab,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { useParams } from 'react-router-dom';

// Definição dos 107 campos da Nota Fiscal com o nome do banco (dbColumn)
const notaFiscalFields = [
  { label: "ID Nota Fiscal", key: "idNotaFiscal", dbColumn: "ID_NFE", disabled: true },
  { label: "Natureza Operação", key: "naturezaOperacao", dbColumn: "NATOP" },
  { label: "Forma Pagamento", key: "formaPagamento", dbColumn: "INDPAG" },
  { label: "Série", key: "serie", dbColumn: "SERIE" },
  { label: "Número NF", key: "numeroNF", dbColumn: "NNF" },
  { label: "Número Pedido Cliente", key: "numeroPedidoCliente", dbColumn: "numero_pedido_cliente" },
  { label: "Data Emissão", key: "dataEmissao", dbColumn: "DEMI" },
  { label: "Tipo NF", key: "tipoNF", dbColumn: "TPNF" },
  { label: "Tipo Pessoa Dest", key: "tipoPessoaDest", dbColumn: "DEST_TPPESSOA" },
  { label: "CPF/CNPJ Dest", key: "cpfCnpjDest", dbColumn: "DEST_NDOC" },
  { label: "Insc. Est Dest", key: "inscEstDest", dbColumn: "DEST_IE" },
  { label: "Código Cliente", key: "codigoCliente", dbColumn: "DEST_CODCLIE" },
  { label: "Nome Dest", key: "nomeDest", dbColumn: "DEST_XNOME" },
  { label: "Endereço Dest", key: "enderecoDest", dbColumn: "DEST_XENDERECO" },
  { label: "Logradouro Dest", key: "logradouroDest", dbColumn: "DEST_ENDERDEST_XLGR" },
  { label: "Número End Dest", key: "numeroEndDest", dbColumn: "DEST_ENDERDEST_NRO" },
  { label: "Complemento End Dest", key: "complementoEndDest", dbColumn: "DEST_ENDERDEST_XCPL" },
  { label: "Bairro Dest", key: "bairroDest", dbColumn: "DEST_ENDERDEST_XBAIRRO" },
  { label: "Código Mun Dest", key: "codigoMunDest", dbColumn: "DEST_ENDERDEST_CMUN" },
  { label: "Município Dest", key: "municipioDest", dbColumn: "DEST_ENDERDEST_XMUN" },
  { label: "UF Dest", key: "ufDest", dbColumn: "DEST_ENDERDEST_UF" },
  { label: "CEP Dest", key: "cepDest", dbColumn: "DEST_ENDERDEST_CEP" },
  { label: "Peso Bruto Veículo Transp", key: "pesoBrutoVeiculoTransporte", dbColumn: "TRANSP_VOL_PESOB" },
  { label: "Peso Líquido Veículo Transp", key: "pesoLiquidoVeiculoTransporte", dbColumn: "TRANSP_VOL_PESOL" },
  { label: "Modalidade Frete", key: "modalidadeFrete", dbColumn: "TRANSP_MODFRETE" },
  { label: "Tipo Pessoa Transp", key: "tipoPessoaTransp", dbColumn: "TRANSP_TRANSPORTA_TPPESSOA" },
  { label: "CPF/CNPJ Transp", key: "cpfCnpjTransp", dbColumn: "TRANSP_TRANSPORTA_NDOC" },
  { label: "Nome Transp", key: "nomeTransp", dbColumn: "TRANSP_TRANSPORTA_XNOME" },
  { label: "Insc. Est Transp", key: "inscEstTransp", dbColumn: "TRANSP_TRANSPORTA_IE" },
  { label: "Endereço Transp", key: "enderecoTransp", dbColumn: "TRANSP_TRANSPORTA_XENDER" },
  { label: "Município Transp", key: "municipioTransp", dbColumn: "TRANSP_TRANSPORTA_XMUN" },
  { label: "UF Transp", key: "ufTransp", dbColumn: "TRANSP_TRANSPORTA_UF" },
  { label: "Informações Complementares", key: "informacoesComplementares", dbColumn: "INFADIC_INFCPL" },
  { label: "Justificativa Cancelamento", key: "justificativaCancelamento", dbColumn: "X_JUST_CANC" },
  { label: "Justificativa Inutilização", key: "justificativaInutilizacao", dbColumn: "X_JUST_INUT" },
  { label: "Total Icms Vlr Prod", key: "totalIcmsVlrProd", dbColumn: "TOTAL_ICMSTOT_VPROD" },
  { label: "Total Icms Vlr Frete", key: "totalIcmsVlrFrete", dbColumn: "TOTAL_ICMSTOT_VFRETE" },
  { label: "Total Icms Vlr Seguro", key: "totalIcmsVlrSeguro", dbColumn: "TOTAL_ICMSTOT_VSEG" },
  { label: "Total Icms Vlr Desc", key: "totalIcmsVlrDesc", dbColumn: "TOTAL_ICMSTOT_VDESC" },
  { label: "Total Icms Vlr II", key: "totalIcmsVlrII", dbColumn: "TOTAL_ICMSTOT_VII" },
  { label: "Total Icms Vlr IPI", key: "totalIcmsVlrIPI", dbColumn: "TOTAL_ICMSTOT_VIPI" },
  { label: "Total Icms Vlr PIS", key: "totalIcmsVlrPIS", dbColumn: "TOTAL_ICMSTOT_VPIS" },
  { label: "Total Icms Vlr COFINS", key: "totalIcmsVlrCOFINS", dbColumn: "TOTAL_ICMSTOT_VCOFINS" },
  { label: "Total Icms Vlr Outros", key: "totalIcmsVlrOutros", dbColumn: "TOTAL_ICMSTOT_VOUTRO" },
  { label: "Total ISS Vlr Serv", key: "totalISSVlrServ", dbColumn: "TOTAL_ISSQNTOT_VSERV" },
  { label: "Total Icms Vlr ISS", key: "totalIcmsVlrISS", dbColumn: "TOTAL_ICMSTOT_VISS" },
  { label: "Total Iss Vlr BC", key: "totalIssVlrBC", dbColumn: "TOTAL_ISSTOT_VBC" },
  { label: "Total Icms Vlr ICMS", key: "totalIcmsVlrICMS", dbColumn: "TOTAL_ICMSTOT_VICMS" },
  { label: "Total Icms Vlr BC", key: "totalIcmsVlrBC", dbColumn: "TOTAL_ICMSTOT_VBC" },
  { label: "Total Icms Vlr BCST", key: "totalIcmsVlrBCST", dbColumn: "TOTAL_ICMSTOT_VBCST" },
  { label: "Total Icms Vlr ST", key: "totalIcmsVlrST", dbColumn: "TOTAL_ICMSTOT_VST" },
  { label: "Total Icms Vlr NF", key: "totalIcmsVlrNF", dbColumn: "TOTAL_ICMSTOT_VNF" },
  { label: "Tipo Impressão Danfe", key: "tipoImpressaoDanfe", dbColumn: "tpimp" },
  { label: "Tipo Emissão", key: "tipoEmissao", dbColumn: "tpemis" },
  { label: "DV Chave Acesso", key: "dvChaveAcesso", dbColumn: "DIG_VERIF_CHAVE_ACESSO" },
  { label: "Número Protocolo SF", key: "numeroProtocoloSF", dbColumn: "PROTOCOLO_SF" },
  { label: "Número Recibo SF", key: "numeroReciboSF", dbColumn: "RECIBO_SF" },
  { label: "Telefone Dest", key: "telefoneDest", dbColumn: "DEST_FONE" },
  { label: "DDD Telefone", key: "dddTelefone", dbColumn: "DDD" },
  { label: "Cod ANTT Transp", key: "codANTTTransp", dbColumn: "TRANSP_COD_ANTT" },
  { label: "Placa Veic Transp", key: "placaVeicTransp", dbColumn: "TRANSP_PLACA_VEICULO" },
  { label: "UF Placa Veic Transp", key: "ufPlacaVeicTransp", dbColumn: "TRANSP_UF_PLACA_VEICULO" },
  { label: "Insc. Subst Tributário", key: "inscEstSubstTributario", dbColumn: "INSCREST_SUBST_TRIBUT" },
  { label: "UF Insc. Subst Tributário", key: "ufInscEstSubstTributario", dbColumn: "UF_INSCREST_SUBST_TRIBUT" },
  { label: "Volume Quantidade", key: "volumeQuantidade", dbColumn: "VOL_QTDADE" },
  { label: "Volume Espécie", key: "volumeEspecie", dbColumn: "VOL_ESPECIE" },
  { label: "Volume Marca", key: "volumeMarca", dbColumn: "VOL_MARCA" },
  { label: "Volume Numeração", key: "volumeNumeracao", dbColumn: "VOL_NUMERACAO" },
  { label: "Status", key: "status", dbColumn: "status" },
  { label: "Email Dest", key: "emailDest", dbColumn: "DEST_EMAIL" },
  { label: "Email Transportadora", key: "emailTransportadora", dbColumn: "DEST_TRANSPORTADORA" },
  { label: "Email Cópia", key: "emailCopia", dbColumn: "DEST_COPIA" },
  { label: "Suframa Dest", key: "suframaDest", dbColumn: "DEST_SUFRAMA" },
  { label: "Id Vendedor", key: "idVendedor", dbColumn: "ID_VENDEDOR" },
  { label: "finNFE", key: "finNFE", dbColumn: "finNFE" },
  { label: "Chave NFe20", key: "ChaveNfe20", dbColumn: "CHAVE_NFE20" },
  { label: "Status Email", key: "statusSendEmail", dbColumn: "STATUS_EMAIL" },
  { label: "Cod País", key: "codPais", dbColumn: "COD_PAIS" },
  { label: "Nome País", key: "nomePais", dbColumn: "NOME_PAIS" },
  { label: "Seq Evento Carta Correção", key: "seqEventoCartaCorrecao", dbColumn: "SEQ_EVENTO_CARTACORRECAO" },
  { label: "Texto Carta Correção", key: "textoCartaCorrecao", dbColumn: "TEXTO_CARTACORRECAO" },
  { label: "Valor Total Impostos NF", key: "valorTotalImpostosNF", dbColumn: "VALOR_TOTAL_IMPOSTOS_NF" },
  { label: "Id Destino", key: "id_Destino", dbColumn: "ID_DEST" },
  { label: "Descrição Série NFe", key: "descricaoSerieNfe", dbColumn: "DESCRICAO_SERIE" },
  { label: "Ind Pres", key: "indPres", dbColumn: "IND_PRES" },
  { label: "Ind Final", key: "indFinal", dbColumn: "IND_FINALS" },
  { label: "Total VICMSDeson", key: "total_VICMSDeson", dbColumn: "total_VICMSDeson" },
  { label: "Chave NFe Origem Devolução", key: "chaveNfeOrigemDevolucao", dbColumn: "CHAVE_NFE_ORIGEM_DEVOLUCAO" },
  { label: "Chave NFe310 Gerado", key: "ChaveNfe310Gerado", dbColumn: "CHAVE_NFE310_GERADO" },
  { label: "Total vFCPUFDest", key: "total_vFCPUFDest", dbColumn: "total_vFCPUFDest" },
  { label: "Total vICMSUFDest", key: "total_vICMSUFDest", dbColumn: "total_vICMSUFDest" },
  { label: "Total vICMSUFRemet", key: "total_vICMSUFRemet", dbColumn: "total_vICMSUFRemet" },
  { label: "Ind IE Dest", key: "indIEDest", dbColumn: "Ind_IE_Dest" },
  { label: "QR Code", key: "qrCode", dbColumn: "qr_code" },
  { label: "ID CSC", key: "idCsc", dbColumn: "id_csc", disabled: true },
  { label: "Código CSC", key: "codigoCsc", dbColumn: "codigo_csc" },
  { label: "vFCPUFdest", key: "vfcpufdest", dbColumn: "vfcpufdest" },
  { label: "vicmsufdest", key: "vicmsufdest", dbColumn: "vicmsufdest" },
  { label: "vicmsufremet", key: "vicmsufremet", dbColumn: "vicmsufremet" },
  { label: "vFCP", key: "vFCP", dbColumn: "vFCP" },
  { label: "vFCPST", key: "vFCPST", dbColumn: "vFCPST" },
  { label: "vFCPSTRet", key: "vFCPSTRet", dbColumn: "vFCPSTRet" },
  { label: "vIPIDevol", key: "vIPIDevol", dbColumn: "vIPIDevol" },
  { label: "Modelo Documento Fiscal", key: "modeloDocumentoFiscal", dbColumn: "modelo_documento_fiscal" },
  { label: "nnf Produtor", key: "nnfProdutor", dbColumn: "nnf_produtor" },
  { label: "Código Uf Produtor", key: "codigoUfProdutor", dbColumn: "codigo_uf_produtor" },
  { label: "Nota MS Premiada", key: "notaMsPremiada", dbColumn: "nota_ms_premiada" }
];

// Definição dos campos dos Itens – Grupo 1 (campos 1 a 46)
const itemFieldsGroup1 = [
  { label: "ID Item Nota", key: "idItemNota", dbColumn: "ID_NFE_ITENS", disabled: true },
  { label: "Número Item", key: "numeroItem", dbColumn: "NITEM" },
  { label: "Código Produto", key: "codProduto", dbColumn: "CPROD" },
  { label: "Nome Produto", key: "nomeProduto", dbColumn: "XPROD" },
  { label: "Código FOP", key: "codFOP", dbColumn: "CFOP" },
  { label: "Código EAN", key: "codEAN", dbColumn: "CEAN" },
  { label: "Unidade Comercial", key: "unidComercial", dbColumn: "UCOM" },
  { label: "Quantidade Comercial", key: "quantComercial", dbColumn: "QCOM" },
  { label: "Valor Unitário Comercial", key: "valorUnComercial", dbColumn: "VUNCOM" },
  { label: "Valor Total Produto", key: "valorTotProduto", dbColumn: "VPROD" },
  { label: "Código EAN Tributável", key: "codEANTributavel", dbColumn: "CEANTRIB" },
  { label: "Unidade Tributável", key: "unidTributavel", dbColumn: "UTRIB" },
  { label: "Quantidade Tributável", key: "quantTributavel", dbColumn: "QTRIB" },
  { label: "Valor Unitário Tributável", key: "valorUnTributavel", dbColumn: "VUNTRIB" },
  { label: "Origem ICMS", key: "origemICMS", dbColumn: "ICMS_ORIG" },
  { label: "Código Situação Tributária ICMS", key: "codSitTributariaICMS", dbColumn: "ICMS_CST" },
  { label: "Modalidade Base Calc ICMS", key: "modDetBaseCalcICMS", dbColumn: "ICMS_MODBC" },
  { label: "Valor Base Calc ICMS", key: "valorBaseCalcICMS", dbColumn: "ICMS_VBC" },
  { label: "Alíquota ICMS", key: "aliquotaICMS", dbColumn: "ICMS_PICMS" },
  { label: "Percentual Redução Base Calc ICMS", key: "percRedBaseCalcICMS", dbColumn: "ICMS_PREDBC" },
  { label: "Valor ICMS", key: "valorICMS", dbColumn: "ICMS_VICMS" },
  { label: "Modalidade Base Calc ICMS ST", key: "modDetBaseCalcICMSST", dbColumn: "ICMS_MODBCST" },
  { label: "Percentual Margem Adic ICMS ST", key: "percMargemValorAdicICMSST", dbColumn: "ICMS_PMVAST" },
  { label: "Percentual Redução Base Calc ICMS ST", key: "percRedBaseCalcICMSST", dbColumn: "ICMS_PREDBCST" },
  { label: "Valor Base Calc ICMS ST", key: "valorBaseCalcICMSST", dbColumn: "ICMS_VBCST" },
  { label: "Alíquota ICMS ST", key: "aliquotaICMSST", dbColumn: "ICMS_PICMSST" },
  { label: "Valor ICMS ST", key: "valorICMSST", dbColumn: "ICMS_VICMSST" },
  { label: "Código Situação Tributária IPI", key: "codSitTribIPI", dbColumn: "IPI_CST" },
  { label: "Valor Base Calc IPI", key: "valorBaseCalcIPI", dbColumn: "IPI_VBC" },
  { label: "Quantidade Univ. Tributável IPI", key: "quantUnidTribIPI", dbColumn: "IPI_QUNID" },
  { label: "Valor Univ. Tributável IPI", key: "valorUnidTribIPI", dbColumn: "IPI_VUNID" },
  { label: "Alíquota IPI", key: "aliquotaIPI", dbColumn: "IPI_PIPI" },
  { label: "Valor IPI", key: "valorIPI", dbColumn: "IPI_VIPI" },
  { label: "Código Situação Tributária PIS", key: "codSitTribPIS", dbColumn: "PIS_CST" },
  { label: "Valor Base PIS", key: "valorBasePIS", dbColumn: "PIS_VBC" },
  { label: "Alíquota PIS", key: "aliquotaPIS", dbColumn: "PIS_PPIS" },
  { label: "Valor PIS", key: "valorPIS", dbColumn: "PIS_VPIS" },
  { label: "Código Situação Tributária COFINS", key: "codSitTribCOFINS", dbColumn: "COFINS_CST" },
  { label: "Valor Base COFINS", key: "valorBaseCOFINS", dbColumn: "COFINS_VBC" },
  { label: "Alíquota COFINS", key: "aliquotaCOFINS", dbColumn: "COFINS_PCOFINS" },
  { label: "Valor COFINS", key: "valorCOFINS", dbColumn: "COFINS_VCOFINS" },
  { label: "Código NCM", key: "codigoNCM", dbColumn: "NCM" },
  { label: "Código EXTIPI", key: "codigoEXTIPI", dbColumn: "EXTIPI" },
  { label: "Gênero", key: "genero", dbColumn: "GENERO" },
  { label: "vFrete", key: "vFrete", dbColumn: "vFrete" },
  { label: "vSeg", key: "vSeg", dbColumn: "vSeg" }
];

// Definição dos campos dos Itens – Grupo 2 (campos 47 a 92)
const itemFieldsGroup2 = [
  { label: "vDesc", key: "vDesc", dbColumn: "vDesc" },
  { label: "vOutro", key: "vOutro", dbColumn: "vOutro" },
  { label: "indTot", key: "indTot", dbColumn: "indtot" },
  { label: "Inf Ad Prod", key: "infAdProd", dbColumn: "infadprod" },
  { label: "Tag DI nDI", key: "tagDI_nDI", dbColumn: "tagDI_nDI" },
  { label: "Tag DI dDI", key: "tagDI_dDI", dbColumn: "tagDI_dDI" },
  { label: "Tag DI xLoc Desemb", key: "tagDI_xLocDesemb", dbColumn: "tagDI_xLocDesemb" },
  { label: "Tag DI UF Desemb", key: "tagDI_UFDesemb", dbColumn: "tagDI_UFDesemb" },
  { label: "Tag DI dDesemb", key: "tagDI_dDesemb", dbColumn: "tagDI_dDesemb" },
  { label: "Tag DI cExportador", key: "tagDI_cExportador", dbColumn: "tagDI_cExportador" },
  { label: "Tag DI nAdicao", key: "tagDI_nAdicao", dbColumn: "tagDI_nAdicao" },
  { label: "Tag DI nSeq Adic", key: "tagDI_nSeqAdic", dbColumn: "tagDI_nSeqAdic" },
  { label: "Tag DI cFabricante", key: "tagDI_cFabricante", dbColumn: "tagDI_cFabricante" },
  { label: "Tag DI vDesc DI", key: "tagDI_vDescDI", dbColumn: "tagDI_vDescDI" },
  { label: "Tag II vBC", key: "tagII_vBC", dbColumn: "tagII_vBC" },
  { label: "Tag II vDesp Adu", key: "tagII_vDespAdu", dbColumn: "tagII_vDespAdu" },
  { label: "Tag II vII", key: "tagII_vII", dbColumn: "tagII_vII" },
  { label: "Tag II vIOF", key: "tagII_vIOF", dbColumn: "tagII_vIOF" },
  { label: "CSOSN", key: "cod_CSOSN", dbColumn: "CSOSN" },
  { label: "C Prod ANP", key: "cProdANP", dbColumn: "C_Prod_ANP" },
  { label: "Valor Total Impostos ITEM", key: "valorTotalImpostosITEM", dbColumn: "VALOR_TOTAL_IMPOSTOS_ITEM" },
  { label: "vICMSOp", key: "vICMSOp", dbColumn: "vICMSOp" },
  { label: "pDif", key: "pDif", dbColumn: "pdif" },
  { label: "vICMSDif", key: "vICMSDif", dbColumn: "vICMSDif" },
  { label: "vICMSDeson", key: "vICMSDeson", dbColumn: "vICMSDeson" },
  { label: "Mot Des ICMS", key: "motDesICMS", dbColumn: "motdesicms" },
  { label: "NFCI", key: "CodigoNfci", dbColumn: "nFCI" },
  { label: "Código CEST", key: "codigoCEST", dbColumn: "codigo_CEST" },
  { label: "vBCUFDest", key: "vBCUFDest", dbColumn: "vBCUFDest" },
  { label: "pFCPUFDest", key: "pFCPUFDest", dbColumn: "pFCPUFDest" },
  { label: "pICMSUFDest", key: "pICMSUFDest", dbColumn: "pICMSUFDest" },
  { label: "pICMSInter", key: "pICMSInter", dbColumn: "pICMSInter" },
  { label: "pICMSInterPart", key: "pICMSInterPart", dbColumn: "pICMSInterPart" },
  { label: "vFCPUFDest", key: "vFCPUFDest", dbColumn: "vFCPUFDest" },
  { label: "vICMSUFDest", key: "vICMSUFDest", dbColumn: "vICMSUFDest" },
  { label: "vICMSUFRemet", key: "vICMSUFRemet", dbColumn: "vICMSUFRemet" },
  { label: "vBCFCPUFDest", key: "vBCFCPUFDest", dbColumn: "vBCFCPUFDest" },
  { label: "vBCFCPST", key: "vBCFCPST", dbColumn: "vBCFCPST" },
  { label: "pFCPST", key: "pFCPST", dbColumn: "pFCPST" },
  { label: "vFCPST", key: "vFCPST", dbColumn: "vFCPST" },
  { label: "Peso Líquido", key: "pesoLiquido", dbColumn: "peso_liquido" },
  { label: "cBenef", key: "cBenef", dbColumn: "cod_beneficio" },
  { label: "Lote", key: "lote", dbColumn: "NLote" },
  { label: "Validade", key: "validade", dbColumn: "DVal" },
  { label: "Fabricação", key: "fabricacao", dbColumn: "DFab" },
  { label: "Código Anvisa", key: "codigoAnvisa", dbColumn: "CProdANVISA" }
];

// Se não houver campos extras, defina um array vazio para itemFieldsGroup3
const itemFieldsGroup3 = [];

const SuporteNFESICTabs = () => {
  const { idNfe } = useParams();
  const [notaFiscal, setNotaFiscal] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [selectedTab, setSelectedTab] = useState(0);
  const [mensagemUsuario, setMensagemUsuario] = useState('');
  const [motivoRejeicao, setMotivoRejeicao] = useState('');

  // Estados para filtro geral
  const [filterNotaInput, setFilterNotaInput] = useState('');
  const [filterItemInput, setFilterItemInput] = useState('');
  const [filterNotaText, setFilterNotaText] = useState('');
  const [filterItemText, setFilterItemText] = useState('');

  // Estados para o popup de detalhes do item
  const [selectedItemIndex, setSelectedItemIndex] = useState(null);
  const [popupFilter, setPopupFilter] = useState('');

  useEffect(() => {
    const fetchNotaFiscal = async () => {
      setLoading(true);
      setError('');
      try {
        const response = await axios.get(`/api/nfe/listSuporte/${idNfe}`);
        setNotaFiscal(response.data);
      } catch (err) {
        setError('Erro ao buscar nota fiscal');
        setNotaFiscal(null);
      } finally {
        setLoading(false);
      }
    };
    fetchNotaFiscal();
  }, [idNfe]);

  // Debounce para filtro na Nota Fiscal
  useEffect(() => {
    const handler = setTimeout(() => {
      setFilterNotaText(filterNotaInput);
    }, 300);
    return () => clearTimeout(handler);
  }, [filterNotaInput]);

  // Debounce para filtro nos Itens (na visualização resumida)
  useEffect(() => {
    const handler = setTimeout(() => {
      setFilterItemText(filterItemInput);
    }, 300);
    return () => clearTimeout(handler);
  }, [filterItemInput]);

  // Navegação por teclado entre os campos (mantém-se o mesmo)
  const handleKeyDown = (e, row, col, type, totalRows, totalCols) => {
    let newRow = row, newCol = col;
    if (e.key === 'ArrowRight') {
      newCol = col + 1;
    } else if (e.key === 'ArrowLeft') {
      newCol = col - 1;
    } else if (e.key === 'ArrowDown') {
      newRow = row + 1;
    } else if (e.key === 'ArrowUp') {
      newRow = row - 1;
    }
    if (newRow >= 0 && newRow < totalRows && newCol >= 0 && newCol < totalCols) {
      const newId = type === 'nota' ? `nota-0-${newCol}` : `${type}-${newRow}-${newCol}`;
      const nextElement = document.getElementById(newId);
      if (nextElement) {
        nextElement.focus();
        e.preventDefault();
      }
    }
  };

  const handleNotaFiscalChange = (key, value) => {
    setNotaFiscal(prev => ({
      ...prev,
      [key]: value
    }));
  };

  const handleItemChange = (rowIndex, key, value) => {
    const updatedItems = [...notaFiscal.itens];
    updatedItems[rowIndex] = { ...updatedItems[rowIndex], [key]: value };
    setNotaFiscal(prev => ({
      ...prev,
      itens: updatedItems
    }));
  };

  const handleSave = async () => {
    try {
      await axios.put(`/api/nfe/save`, notaFiscal);
      alert('Dados salvos com sucesso!');
    } catch (err) {
      alert('Erro ao salvar os dados.');
    }
  };

  const textFieldStyle = { minWidth: '150px' };

  // Filtro para Nota Fiscal: verifica key, label, dbColumn e valor do campo
  const visibleNotaFiscalFields = notaFiscal
    ? notaFiscalFields.filter(field => {
        if (!filterNotaText) return true;
        const fieldValue = notaFiscal[field.key] ? String(notaFiscal[field.key]) : '';
        const term = filterNotaText.toLowerCase();
        return (
          field.key.toLowerCase().includes(term) ||
          field.label.toLowerCase().includes(term) ||
          (field.dbColumn && field.dbColumn.toLowerCase().includes(term)) ||
          fieldValue.toLowerCase().includes(term)
        );
      })
    : [];

  // Na aba Itens (visualização resumida): filtra os itens se necessário (aqui você pode ajustar se quiser filtrar os itens pela busca)
  const filteredItems = notaFiscal && notaFiscal.itens
    ? notaFiscal.itens.filter(item => {
        if (!filterItemText) return true;
        const term = filterItemText.toLowerCase();
        // Filtra pelo nome ou código do produto
        const nome = item.nomeProduto ? String(item.nomeProduto).toLowerCase() : '';
        const codigo = item.codProduto ? String(item.codProduto).toLowerCase() : '';
        return nome.includes(term) || codigo.includes(term);
      })
    : [];

  // Função para filtrar os campos do popup de detalhes do item
  const getFilteredPopupFields = () => {
    const allItemFields = [...itemFieldsGroup1, ...itemFieldsGroup2, ...itemFieldsGroup3];
    if (!popupFilter) return allItemFields;
    const term = popupFilter.toLowerCase();
    return allItemFields.filter(field => 
      field.key.toLowerCase().includes(term) ||
      field.label.toLowerCase().includes(term) ||
      (field.dbColumn && field.dbColumn.toLowerCase().includes(term))
    );
  };

  // Fechar o popup
  const handleClosePopup = () => {
    setSelectedItemIndex(null);
    setPopupFilter('');
  };

  return (
    <Box p={3}>
      <Typography variant="h4" gutterBottom>
        SUPORTE SIC-AJUSTE "TECNICO"
      </Typography>
      <Typography variant="h5" gutterBottom>
        Edição de Nota Fiscal
      </Typography>
      {error && (
        <Typography color="error" style={{ marginTop: 10 }}>
          {error}
        </Typography>
      )}
      {loading && (
        <Typography variant="body1" style={{ marginTop: 10 }}>
          Carregando...
        </Typography>
      )}
      {notaFiscal && (
        <>
          <Tabs
            value={selectedTab}
            onChange={(e, newValue) => setSelectedTab(newValue)}
            aria-label="Tabs Nota x Itens"
          >
            <Tab label="Nota Fiscal" />
            <Tab label="Itens" />
          </Tabs>

          {/* Aba Nota Fiscal */}
          <div role="tabpanel" hidden={selectedTab !== 0}>
            <Box p={3}>
              <Box mb={2}>
                <TextField
                  label="Filtro na Nota Fiscal (colunas)"
                  variant="outlined"
                  fullWidth
                  value={filterNotaInput}
                  onChange={(e) => setFilterNotaInput(e.target.value)}
                />
              </Box>
              <TableContainer component={Paper} style={{ overflowX: 'auto' }}>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      {visibleNotaFiscalFields.map((field, colIndex) => (
                        <TableCell key={field.key}>
                          {`${field.label} - ${field.dbColumn}`}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      {visibleNotaFiscalFields.map((field, colIndex) => (
                        <TableCell key={field.key}>
                          <TextField
                            id={`nota-0-${colIndex}`}
                            fullWidth
                            style={textFieldStyle}
                            value={notaFiscal[field.key] || ''}
                            onChange={(e) =>
                              handleNotaFiscalChange(field.key, e.target.value)
                            }
                            onKeyDown={(e) =>
                              handleKeyDown(
                                e,
                                0,
                                colIndex,
                                'nota',
                                1,
                                visibleNotaFiscalFields.length
                              )
                            }
                            variant="outlined"
                            size="small"
                            disabled={field.disabled || false}
                          />
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
              <Box mt={3}>
                <TextField
                  label="Mensagem ao usuário na próxima rejeição"
                  multiline
                  rows={4}
                  fullWidth
                  variant="outlined"
                  value={mensagemUsuario}
                  onChange={(e) => setMensagemUsuario(e.target.value)}
                />
              </Box>
              <Box mt={3}>
                <TextField
                  label="Motivo Rejeição"
                  fullWidth
                  variant="outlined"
                  value={motivoRejeicao}
                  disabled
                />
              </Box>
            </Box>
          </div>

          {/* Aba Itens – Visualização Resumida */}
          <div role="tabpanel" hidden={selectedTab !== 1}>
            <Box p={3}>
              <Box mb={2}>
                <TextField
                  label="Filtro nos Itens (nome/código)"
                  variant="outlined"
                  fullWidth
                  value={filterItemInput}
                  onChange={(e) => setFilterItemInput(e.target.value)}
                />
              </Box>
              <TableContainer component={Paper} style={{ overflowX: 'auto' }}>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell>Código Produto</TableCell>
                      <TableCell>Nome Produto</TableCell>
                      <TableCell>Ações</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {filteredItems.map((item, rowIndex) => (
                      <TableRow key={item.idItemNota || rowIndex}>
                        <TableCell>{item.codProduto || '-'}</TableCell>
                        <TableCell>{item.nomeProduto || '-'}</TableCell>
                        <TableCell>
                          <IconButton
                            onClick={() => setSelectedItemIndex(rowIndex)}
                            aria-label="Detalhes"
                          >
                            <SearchIcon />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </div>

          <Box mt={3}>
            <Button variant="contained" color="primary" onClick={handleSave}>
              Salvar
            </Button>
          </Box>
        </>
      )}

      {/* Popup de detalhes do item */}
      <Dialog
        open={selectedItemIndex !== null}
        onClose={handleClosePopup}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Detalhes do Item</DialogTitle>
        <DialogContent dividers>
          <Box mb={2}>
            <TextField
              label="Filtrar campos"
              variant="outlined"
              fullWidth
              value={popupFilter}
              onChange={(e) => setPopupFilter(e.target.value)}
            />
          </Box>
          {selectedItemIndex !== null && notaFiscal && notaFiscal.itens && (
            <TableContainer component={Paper} style={{ maxHeight: '60vh' }}>
              <Table size="small" stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell>Campo (Label - DB)</TableCell>
                    <TableCell>Valor</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {getFilteredPopupFields().map((field) => (
                    <TableRow key={field.key}>
                      <TableCell>{`${field.label} - ${field.dbColumn}`}</TableCell>
                      <TableCell>
                        <TextField
                          fullWidth
                          variant="outlined"
                          size="small"
                          value={
                            notaFiscal.itens[selectedItemIndex][field.key] || ''
                          }
                          onChange={(e) =>
                            handleItemChange(
                              selectedItemIndex,
                              field.key,
                              e.target.value
                            )
                          }
                          disabled={field.disabled || false}
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClosePopup} color="primary">
            Fechar
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default SuporteNFESICTabs;
